import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Users: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${rotation ?? 0})`}
      fill="none"
      viewBox="0 0 45 45"
    >
      <g>
        <path
          stroke={color ?? 'currentColor'}
          strokeWidth="3.74988"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M29.9984 39.3733V35.6234C29.9984 33.6344 29.2082 31.7268 27.8017 30.3203C26.3953 28.9138 24.4877 28.1237 22.4986 28.1237H11.249C9.25994 28.1237 7.35235 28.9138 5.94587 30.3203C4.5394 31.7268 3.74925 33.6344 3.74925 35.6234V39.3733"
        />
        <path
          stroke={color ?? 'currentColor'}
          strokeWidth="3.74988"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M30.0027 5.86246C31.6109 6.27939 33.0352 7.21853 34.052 8.53249C35.0687 9.84644 35.6204 11.4608 35.6204 13.1222C35.6204 14.7836 35.0687 16.398 34.052 17.7119C33.0352 19.0259 31.6109 19.965 30.0027 20.382"
        />
        <path
          stroke={color ?? 'currentColor'}
          strokeWidth="3.74988"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M41.2507 39.3749V35.625C41.2494 33.9633 40.6963 32.3491 39.6783 31.0357C38.6602 29.7224 37.2348 28.7844 35.6258 28.369"
        />
        <path
          stroke={color ?? 'currentColor'}
          strokeWidth="3.74988"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16.8721 20.625C21.0141 20.625 24.3719 17.2672 24.3719 13.1252C24.3719 8.98324 21.0141 5.62549 16.8721 5.62549C12.7301 5.62549 9.3724 8.98324 9.3724 13.1252C9.3724 17.2672 12.7301 20.625 16.8721 20.625Z"
        />
      </g>
    </svg>
  </IconWrapper>
);

Users.displayName = 'Users';
